import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";

export const RESTRICTED_AMENITY_KEYS = [
  "safelisting",
  "permanent_parking",
  "pool",
  "tennis",
  "gym",
  "recreation",
] as const;

export type RestrictedAmenityKey = (typeof RESTRICTED_AMENITY_KEYS)[number];

export const RESTRICTED_AMENITY_LABELS: Record<RestrictedAmenityKey, string> = {
  safelisting: "Safelistings",
  permanent_parking: "Permanent parking",
  pool: "Pool",
  tennis: "Tennis",
  gym: "Gym",
  recreation: "Recreation",
};

export const RESTRICTED_AMENITY_GROUPS: ReadonlyArray<{
  label: string;
  keys: readonly RestrictedAmenityKey[];
}> = [
  {label: "Access", keys: ["safelisting", "permanent_parking"]},
  {label: "Facilities", keys: ["pool", "tennis", "gym", "recreation"]},
];

export function formatRestrictedAmenityKeys(keys: string[] | null | undefined): string {
  if (!keys?.length) return "—";
  return keys
    .map((key) => RESTRICTED_AMENITY_LABELS[key as RestrictedAmenityKey] ?? key)
    .join(", ");
}

/** Household summary uses `YYYY-MM-DD` (end of that calendar day). History uses ISO instant. */
export function formatRestrictedUntilDisplay(until: string | null | undefined): string {
  if (until == null || until === "") return "No end date";

  const trimmed = until.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return `${formatDate(trimmed)} 23:59`;
  }

  if (trimmed.includes("T")) {
    return `${formatDate(trimmed)} ${formatTime(trimmed)}`;
  }

  return formatDate(trimmed);
}
